import type { ReactElement } from 'react';

import { Media } from './Media';
import type { MediaProps } from './types';

export const isMediaElement = (elem: unknown): elem is ReactElement<MediaProps> => {
  const asMedia = elem as ReactElement<MediaProps>;

  if (asMedia.type === Media) {
    return true;
  }
  const { imageSource, videoSource } = asMedia.props;
  return !!imageSource || !!videoSource;
};
